var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Vue, Component, Watch } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { LicenseState } from "@/app/store/modules/license.state";
import { AppConfigState } from "@/app/store/modules/appconfig.state";
import { LeftMenuState } from "@/common/enums/left-menu-state";
import { MenuLinkModel } from "@/app/models/menu-link.model";
import { HostingOptionEnum, AssureEditionEnum } from "@/app/api/battery-portal-api";
import RouteNames from "@/app/router/routes";
import { isLicenseAllowed } from "@/app/utils/license-helper";
let LeftMenuVue = class LeftMenuVue extends Vue {
    constructor() {
        super(...arguments);
        this.route = "";
        this.menu = "";
        this.isMenuOpen = false;
        this.links = [];
    }
    created() {
        this.buildMenuLinks();
    }
    ;
    buildMenuLinks() {
        this.links = [
            new MenuLinkModel(RouteNames.Home, "", "Dashboard", "fa-globe"),
            new MenuLinkModel(RouteNames.Snapshot, "", "Snapshot", "fa-bar-chart"),
            new MenuLinkModel(RouteNames.RealTime, "", "Real-Time", "fa-area-chart", true, undefined, { hostingOption: HostingOptionEnum.OnPrem }),
            new MenuLinkModel(RouteNames.Trend, "", "Trend", "fa-line-chart", true, undefined, { minimumEdition: AssureEditionEnum.OnPremStandard }),
            new MenuLinkModel(RouteNames.Discharge, "", "Discharge", "fa-plug", true, undefined, { minimumEdition: AssureEditionEnum.OnPremStandard }),
            new MenuLinkModel(RouteNames.Alarms, "", "Alarms", "fa-exclamation-triangle"),
            new MenuLinkModel(RouteNames.Events, "", "Alarm Events", "fa-list", true, undefined, { minimumEdition: AssureEditionEnum.OnPremStandard }),
            new MenuLinkModel(RouteNames.Issues, "", "Issues", "fa-exclamation", true, undefined, { minimumEdition: AssureEditionEnum.OnPremStandard }),
            new MenuLinkModel(RouteNames.MaintenanceComments, "", "Comments", "fa-wrench"),
            new MenuLinkModel(RouteNames.Communications, "", "Comms", "fa-wifi"),
            new MenuLinkModel(RouteNames.Companies, "", "Companies", "fa-phone", this.isPowerShield || this.isClientAdministrator),
            new MenuLinkModel(RouteNames.Systems, "", "Systems", "fa-desktop"),
            new MenuLinkModel(RouteNames.Users, "", "Users", "fa-users", this.isPowerShield || this.isClientAdministrator),
            new MenuLinkModel(RouteNames.Notifications, "", "Notifications", "fa-envelope", this.isPowerShield || this.isClientAdministrator, undefined, { minimumEdition: AssureEditionEnum.OnPremStandard }),
            new MenuLinkModel(RouteNames.Reports, "", "Reports", "fa-print"),
            new MenuLinkModel("Configuration", "Configuration", "Configuration", "fa-cog", this.isPowerShield || this.isClientAdministrator, [
                new MenuLinkModel(RouteNames.Applications, "Configuration", "Applications", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.AlarmTypes, "Configuration", "Alarm Types", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.EventTypes, "Configuration", "Alarm Event Types", "", this.isPowerShield || this.isClientAdministrator, undefined, { minimumEdition: AssureEditionEnum.OnPremStandard }),
                new MenuLinkModel(RouteNames.BlockTypes, "Configuration", "Block Types", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.ComponentTypes, "Configuration", "Component Types", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                //new MenuLinkModel(RouteNames.ComponentLimits, "Configuration", "Component Limits", "", this.isPowerShield, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.ComponentLimits, "Configuration", "Component Limits", "", this.isPowerShield),
                new MenuLinkModel(RouteNames.Manufacturers, "Configuration", "Manufacturers", "", this.isPowerShieldAdministrator || this.isClientAdministrator),
                new MenuLinkModel(RouteNames.MeasurementTypes, "Configuration", "Measurement Types", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.Regions, "Configuration", "Geographic Regions", "", this.isPowerShieldAdministrator),
                new MenuLinkModel(RouteNames.SMTPImporterSettings, "Configuration", "SMTP Importer Settings", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.SMTPImporterLogs, "Configuration", "SMTP Importer Logs", "", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
                new MenuLinkModel(RouteNames.ReportPermissions, "Configuration", "Report Permissions", "", this.isPowerShieldAdministrator || this.isClientAdministrator),
            ]),
            new MenuLinkModel(RouteNames.DataGaps, "", "Data Gaps", "fa-database", this.isPowerShieldAdministrator, undefined, { hostingOption: HostingOptionEnum.PowershieldCloud }),
            new MenuLinkModel(RouteNames.About, "", "About", "fa-info-circle", (this.isCloud && this.isPowerShieldAdministrator) || (this.isOnPrem && this.isClientInstaller)),
            new MenuLinkModel(RouteNames.MyProfile, "", "My Profile", "fa-user"),
            new MenuLinkModel(RouteNames.Logout, "", "Sign Out", "fa-power-off"),
        ].filter(link => link);
    }
    ;
    mounted() {
        this.setDefault();
    }
    ;
    setDefault() {
        let route = this.$route;
        if (!route)
            return;
        let link = this.allLinks.filter(link => {
            return link.route == route.name;
        })[0] || this.links[0];
        // ensure navigation panel is collapsed
        if (!this.isPanelCollapsed)
            this.isMenuOpen = link.routeGroup ? true : false;
        else {
            let $body = document.getElementsByTagName("body")[0];
            $body.classList.remove("nav-md");
            $body.classList.toggle("nav-sm");
        }
        this.toggleLink(link);
    }
    ;
    goHome() {
        this.toggleLink(this.links[0]);
    }
    ;
    toggleLink(link) {
        if (!link)
            return;
        this.route = link.route;
        this.menu = link.routeGroup;
        if ((this.isMenuOpen && this.isPanelCollapsed) || !link.routeGroup)
            this.isMenuOpen = false;
    }
    ;
    toggleMenu(menu) {
        if (!menu)
            return;
        if (this.menu == menu.routeGroup && !this.isPanelCollapsed) {
            // collapse this menu if it's clicked again
            this.hideMenus();
            return;
        }
        if (this.menu != menu.routeGroup && !this.isPanelCollapsed) {
            // collpase other menu.
            this.isMenuOpen = false;
        }
        this.menu = menu.routeGroup;
        this.isMenuOpen = !this.isMenuOpen;
    }
    ;
    hideMenus() {
        this.menu = "";
        this.isMenuOpen = false;
    }
    ;
    onPanelCollapsed() {
        if (this.isPanelCollapsed && this.isMenuOpen)
            this.isMenuOpen = false;
    }
    ;
    isCurrentPage(item) {
        if (!item)
            return false;
        let route = this.$route;
        if (!route || !route.name)
            return false;
        var routeName = route.name;
        return routeName.indexOf(item.route) >= 0 ? true : false;
    }
    ;
    get allLinks() {
        return this.links.concat(this.links.map(link => {
            return link.children;
        }).reduce((a, b) => (a || []).concat(b || []), []));
    }
    ;
    get visibleLinks() {
        return this.links.filter(item => item.visible && isLicenseAllowed(item.licenseRule));
    }
    ;
    visibleChildren(children) {
        return children.filter(item => item.visible && isLicenseAllowed(item.licenseRule));
    }
    get loggedIn() {
        return this.loginState.userName ? true : false;
    }
    ;
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    get isPowerShieldAdministrator() {
        return this.loginState.isPowerShieldAdministrator;
    }
    ;
    get isClientAdministrator() {
        return this.loginState.isClientAdministrator;
    }
    ;
    get isClientInstaller() {
        return this.loginState.isClientInstaller;
    }
    ;
    get isCloud() {
        return this.licenseState.isCloud;
    }
    ;
    get isOnPrem() {
        return this.licenseState.isOnPrem;
    }
    ;
    get hasProductionVersion() {
        return this.appState.hasProductionVersion;
    }
    get appVersion() {
        return this.appState.applicationVersion;
    }
    ;
    get appReleaseDesignation() {
        return this.appState.applicationReleaseDesignation;
    }
    ;
    get isPanelCollapsed() {
        return this.loginState.leftMenuState == LeftMenuState.Collapsed ? true : false;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], LeftMenuVue.prototype, "loginState", void 0);
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_b = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _b : Object)
], LeftMenuVue.prototype, "licenseState", void 0);
__decorate([
    State("appConfigModule"),
    __metadata("design:type", typeof (_c = typeof AppConfigState !== "undefined" && AppConfigState) === "function" ? _c : Object)
], LeftMenuVue.prototype, "appState", void 0);
__decorate([
    Watch("isPanelCollapsed"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LeftMenuVue.prototype, "onPanelCollapsed", null);
LeftMenuVue = __decorate([
    Component({
        name: "LeftMenuVue"
    })
], LeftMenuVue);
export default LeftMenuVue;
